module.exports = __webpack_public_path__ + "img/terroir-charcoal-3.ea447c62.jpg";